const MuiTooltipOverrides = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        borderRadius: 0
      }
    }
  }
};

export { MuiTooltipOverrides };
